interface Props {
  style?: React.CSSProperties,
  className?: string
  color?: string
}

export function PlayButton({ style, className = '' }: Props) {
  return (
    <i className={`${className} icon`} style={style}>
      <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.2952 12.6485C1.62853 13.0334 0.795202 12.5523 0.795202 11.7825L0.795201 1.65535C0.795201 0.885549 1.62853 0.404424 2.2952 0.789324L11.0656 5.85289C11.7322 6.23779 11.7322 7.20004 11.0656 7.58494L2.2952 12.6485Z" fill="white"/>
      </svg>
    </i>
  )
}
